import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

import { FlashService } from './services/flash.service';
import { FlashMessage } from './models/flash-message';

@Component({
  selector: 'app-flash',
  templateUrl: './flash.component.html',
  styleUrls: ['./flash.component.sass']
})
export class FlashComponent implements OnInit {
  flashes$: Observable<FlashMessage[]>;

  constructor(
    private flashService: FlashService
  ) { }

  ngOnInit() {
    this.flashes$ = this.flashService.get();
  }

  onClose(id) {
    this.flashService.close(id);
  }
}
